import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./payment-types_style.css";
import { FaUndo } from "react-icons/fa";

function DeletedPaymentTypes ({ setUpdateTrigger, updateTrigger }){

    const [deletedPaymentTypes, setDeletedPaymentTypes] = useState([]);

    const getDeletedPaymentTypes = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/payment_types/getAllDeleted`, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });
            if (res.status === 200) {
                setDeletedPaymentTypes(res.data.data);
            } else {
                Swal.fire("Error", "Hubo un error al obtener los datos eliminados", "error");
            }
        } catch (error) {
            Swal.fire("Error", "Hubo un error al obtener los datos eliminados", "error");
        }
    };

    const restorePaymentType = async (id) => {
        try {
            const result = await Swal.fire({
                title: "¿Estás seguro?",
                text: "¿Quieres restaurar este elemento?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: "Sí, restaurar",
                denyButtonText: "No, cancelar",
                reverseButtons: true,
                buttonsStyling: true,
            });

            if (result.isConfirmed) {
                const response = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/payment_types/restore/${id}`, {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                    },
                });

                Swal.fire("¡Restaurado!", "El elemento ha sido restaurado.", "success");
                setUpdateTrigger(!updateTrigger);
                getDeletedPaymentTypes();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Cancelado");
            }
        } catch (error) {
            Swal.fire("Error", "Hubo un error", "error");
        }
    };

    useEffect(() => {
        getDeletedPaymentTypes();
    }, [updateTrigger]);

    return (
        <div className='table-responsive'>
            <h3 className="mb-4">Tipos de Pago Eliminados</h3>
            <table className="table table-inverse table-hover table-striped table-bordered dataTable no-footer" role="grid">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {deletedPaymentTypes.map((paytype) => (
                        <tr key={paytype.id} data-master-id={paytype.id}>
                            <td>{paytype.name}</td>
                            <td>
                                <FaUndo className='restoreButton' onClick={() => { restorePaymentType(paytype.id) }} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

}

export default DeletedPaymentTypes;